import React from 'react'

export default function MoviebyGenre() {
  return (
    <div>MoviebyGenre</div>
  )
}
